<template>
  <DefaultLayout :disableFacilitatorTools="true">
    <div ref="topdiv">
      <h5>{{ getPageTitle() }}</h5>
      <br />
      <span v-if="practice">
        {{ $t("instructions") }}
        <br />
      </span>

      <div v-if="!newGameCreated && !practice">
        <small class="text-uppercase font-weight-bold">{{ $t("entername") }}</small>
        <base-input
          maxLength="100"
          ref="gamename"
          v-focus
          id="input-gamename"
          v-model="form.gameName"
        />
        <small class="text-uppercase font-weight-bold">{{
          $t("enteradditionalinformation")
        }}</small>
        <base-input
          maxLength="500"
          ref="additional_information"
          v-focus
          id="input-additional_information"
          v-model="form.additional_information"
        />
      </div>

      <div
        class="alert alert-primary"
        role="alert"
        v-if="
          !editmode && !newGameCreated && !practice && $store.state.main.userCreateGameInstructions
        "
      >
        <span v-html="$store.state.main.userCreateGameInstructions" />
        <br />
      </div>

      <div v-if="practice"><br /></div>
      <span v-if="!editmode && !newGameCreated && !limitedFacilitator">
        <ScenarioSelector :locale="form.locale" :showLocaleSelector="!practice" />
        <br />
      </span>

      <div v-if="!editmode && !practice && !newGameCreated">
        <small>{{ $t("savefirsthint") }}</small>
        <br />
        <br />
      </div>

      <div v-if="canEnableComments && !newGameCreated">
        <base-checkbox class="mb-3" v-model="form.enable_comments">
          {{ $t("enablecommenting") }}
        </base-checkbox>
      </div>

      <div v-if="canEnableSurvey && !newGameCreated">
        <base-checkbox class="mb-3" v-model="form.enable_survey">
          {{ $t("enablesurvey") }}
        </base-checkbox>
      </div>
      <div
        v-if="canEnableSurvey && form.enable_survey && !newGameCreated"
        style="margin-left: 30px;"
      >
        <small>{{ $t("surveyscale") }}</small>

        <base-radio name="5" class="mb-1" v-model="form.surveyScale">
          1-5
        </base-radio>
        <base-radio name="7" class="mb-1" v-model="form.surveyScale">
          1-7
        </base-radio>
        <base-radio name="10" class="mb-1" v-model="form.surveyScale">
          1-10
        </base-radio>
        <br />
      </div>

      <div v-if="!editmode && !newGameCreated && canEnableBilling && !practice">
        <base-checkbox class="mb-3" v-model="form.enable_billing">
          {{ $t("enablebilling") }}
        </base-checkbox>
      </div>

      <div v-if="!editmode && !newGameCreated && canEnableDemo && !practice">
        <base-checkbox class="mb-3" v-model="form.demo">
          {{ $t("demo") }}
        </base-checkbox>

        <div v-if="form.demo">
          <base-input
            ref="demoreason"
            v-focus
            id="input-demoreason"
            v-model="form.demoReason"
            v-bind:placeholder="$t('demoreason')"
          />
        </div>
      </div>

      <base-checkbox
        v-if="
          ($store.state.main.userRole === 'superadmin' ||
            $store.state.main.userAddRobots ||
            practice) &&
            !newGameCreated &&
            this.selectedScenario
        "
        class="mb-3"
        v-model="form.enableRobots"
      >
        {{ $t("computerplayers") }}
      </base-checkbox>

      <div v-if="form.enableRobots && !newGameCreated">
        <small class="text-uppercase font-weight-bold">{{ $t("numberofcomputerplayers") }}</small>
        <span class="col-xs-2">
          <base-input
            type="number"
            v-model="form.numberOfRobots"
            style="min-width: 80px; width: 80px"
            @blur="handleRobotPlayerNumberInput"
          ></base-input>
        </span>
      </div>

      <div v-if="false">
        <div v-if="!editmode && !newGameCreated && canCustomizeSimulation">
          <base-checkbox class="mb-3" v-model="form.customizeSimulation">
            {{ $t("customize-simulation") }}
          </base-checkbox>

          <div v-if="form.customizeSimulation">
            <ScenarioCustomizer
              :locale="selectedScenario.locale"
              :scenario="selectedScenario.scenario_id"
              ref="customizer"
            />
          </div>
        </div>
      </div>
     
      <div>
        <CaseSelector 
          v-if="!newGameCreated && selectedScenario && selectedScenario.rps_scenario_id"
          :scenarioId="selectedScenario.rps_scenario_id"
          ref="caseSelector"
        />
      </div>

      <div class="alert alert-primary" role="alert" v-if="alertMessage">
        {{ $t(alertMessage) }}
      </div>
    </div>
    <div v-if="showGamecode()">
      <PlayerObserverLinks
        :gameCode="form.gameCode"
        :showObserverLink="$store.state.main.userViewObserverLink"
      />
    </div>
    <br />
    <div v-if="newGameCreated && !practice">
      <base-button type="primary" @click="cancel()">{{ $t("close") }}</base-button>
    </div>
    <div v-else>
      <base-button type="primary" :disabled="disableSubmit" @click="save()">
        {{ getSubmitButtonText() }}
      </base-button>
      <base-button type="link" class="ml-auto" @click="cancel()">
        {{ $t("cancel") }}
      </base-button>
    </div>
  </DefaultLayout>
</template>

<script>
import {
  createGame,
  getGame,
  updateGameInfo,
  getGameByGameCode,
  getThisAdminInformation
} from "@/services/APIService";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import PlayerObserverLinks from "@/components/PlayerObserverLinks.vue";
import ScenarioCustomizer from "@/components/ScenarioCustomizer.vue";
import ScenarioSelector from "@/components/ScenarioSelector.vue";
import CaseSelector from "@/components/CaseSelector.vue";
import { generateRobots } from "@/services/robot.js";

export default {
  components: {
    DefaultLayout,
    PlayerObserverLinks,
    ScenarioCustomizer,
    ScenarioSelector,
    CaseSelector
  },
  data() {
    return {
      form: {
        gameName: "",
        gameCode: "",
        demo: false,
        demoReason: "",
        additional_information: "",
        enable_comments: false,
        enable_survey: false,
        enable_billing: false,
        surveyScale: "7",
        customizeSimulation: false,
        enableRobots: false,
        enableSuggestions: true,
        numberOfRobots: 7,
        customizeCases: false,
        showCaseSelection: false
      },
      newGameCreated: false,
      editmode: false,
      editid: 0,
      alertMessage: "",
      disableSubmit: false,
      selectedScenario: null,
      practice: false,
      newGameId: null,
      practiceScenarioId: null,
      practiceRPSScenarioId: null,
      previousNumberOfRobots: 7
    };
  },
  async mounted() {
    if (
      this.$route.name === "admingamesdialogpractice" ||
      this.$route.name === "admingamesdialogpracticelimited"
    ) {
      this.practice = true;

      await getThisAdminInformation().then(resp => {
        this.form.gameName = resp.first_name + " " + resp.last_name + " " + this.$t("practicegame");
      });
    }

    if (this.$route.params.gameid) {
      this.editmode = true;
      this.editid = this.$route.params.gameid;
      this.initEditmode();
    }

    if (this.$route.params.gamecode) {
      // limited facilitator
      await getGameByGameCode(this.$route.params.gamecode).then(resp => {
        this.practiceScenarioId = resp.scenario;
        this.practiceRPSScenarioId = resp.rps_scenario;
      });
    }

    this.$bus.$on("simulation-cloned", id => {
      this.simulationCloned(id);
    });

    this.$bus.$on("games-dialog-enable-submit", () => {
      this.disableSubmit = false;
    });

    this.$bus.$on("scenario-selector-scenario-selected", scenario => {
      this.scenarioSelected(scenario);
    });
  },
  beforeDestroy() {
    this.$bus.$off("simulation-cloned");
    this.$bus.$off("games-dialog-enable-submit");
    this.$bus.$off("scenario-selector-scenario-selected");
  },
  computed: {
    limitedFacilitator() {
      return this.$store.state.main.userRole === "limited_facilitator";
    },
    canEnableSurvey() {
      if (this.editMode || !this.selectedScenario || !this.$store.state.main.userEnableSurvey) {
        return false;
      }
      return this.selectedScenario.enable_survey;
    },
    canEnableDemo() {
      return this.$store.state.main.userEnableDemoGames;
    },
    canEnableBilling() {
      return this.$store.state.main.userEnableBilling;
    },
    canCustomizeSimulation() {
      if (
        !this.selectedScenario ||
        !this.selectedScenario.scenario_id ||
        !this.$store.state.main.userCustomizeSimulations
      ) {
        return false;
      } else {
        return true;
      }
    },
    canEnableComments() {
      return false;
      /*
      Replaced 6.3.2023 with suggestions

      if (
        this.editMode ||
        !this.selectedScenario ||
        !this.$store.state.main.userEnableComments
      ) {
        return false;
      }

      return this.selectedScenario.enable_comments;*/
    },
    canEnableSuggestions() {
      if (this.editMode || !this.selectedScenario) {
        return false;
      }

      return true;
    },
    enableComments() {
      return this.canEnableComments && this.form.enable_comments;
    },
    enableSurvey() {
      return this.canEnableSurvey && this.form.enable_survey;
    },
    isClassic() {
      return this.selectedScenario && this.selectedScenario.scenario_id != null;
    },
    showCaseSelector() {
      return !this.isClassic && this.selectedScenario;
    }
  },
  methods: {
    handleRobotPlayerNumberInput(event) {
      if (this.form.numberOfRobots >= 1 && this.form.numberOfRobots <= 20) {
        this.previousNumberOfRobots = this.form.numberOfRobots;
      } else {
        this.form.numberOfRobots = this.previousNumberOfRobots;
      }
    },
    scenarioSelected(scenario) {
      this.selectedScenario = scenario;
    },
    showGamecode() {
      return !this.practice && this.form.gameCode !== "";
    },
    initEditmode() {
      getGame(this.editid).then(game => {
        this.form.gameName = game.name;
        this.form.gameCode = game.game_code;
        this.form.additional_information = game.additional_information;
      });
    },
    getSubmitButtonText() {
      if (this.practice) {
        return this.$t("start");
      } else {
        return this.$t("save");
      }
    },
    getPageTitle() {
      if (this.practice) {
        return this.$t("practicegame");
      } else if (this.newGameCreated) {
        return this.$t("gamecreated");
      } else if (this.editmode) {
        return this.$t("edit");
      } else {
        return this.$t("createnew");
      }
    },
    getUrl() {
      return window.location.origin + "/gamecode/" + this.form.gameCode;
    },
    cancel() {
      this.$router.push("/admin/games/");
    },
    async save() {
      if (!this.editmode) {
        // Let's create a new game. Let's not close the dialog as we have to show some data to the user.
        this.alertMessage = "";

        if (!this.practice && (!this.form.gameName || !this.selectedScenario)) {
          this.alertMessage = "allfieldsrequired";
          return;
        }

        if (
          this.practice &&
          !this.selectedScenario &&
          !this.practiceScenarioId &&
          !this.practiceRPSScenarioId
        ) {
          this.alertMessage = "allfieldsrequired";
          return;
        }

        if (this.form.demo && !this.form.demoReason) {
          this.alertMessage = "demoreasonrequired";
          return;
        }

        this.disableSubmit = true;

        let isClassic = null;
        let scenario_id = null;
        let rps_scenario_id = null;
        let enableComments = null;
        let enableSurvey = null;

        if (this.limitedFacilitator) {
          isClassic = this.practiceScenarioId != null;
          scenario_id = this.practiceScenarioId;
          rps_scenario_id = this.practiceRPSScenarioId;

          await getGameByGameCode(this.$route.params.gamecode).then(resp => {
            enableSurvey = resp.enable_survey;
            enableComments = resp.enable_comments;
          });
        } else {
          isClassic = this.selectedScenario.scenario_id != null;
          scenario_id = this.selectedScenario.scenario_id;
          rps_scenario_id = this.selectedScenario.rps_scenario_id;
          enableComments = isClassic ? this.enableComments : false;
          enableSurvey = isClassic ? this.enableSurvey : false;
        }

        const simulation_type = isClassic ? "classic" : "rockpaperscissors";

        const selectedCases = this.$refs.caseSelector && this.$refs.caseSelector.selectedCaseNumbers ? 
          this.$refs.caseSelector.selectedCaseNumbers.split(',').map((caseNumber, index) => `${caseNumber}=${index + 1}`).join(',') : null;

        if (this.form.customizeSimulation) {
          this.$bus.$emit("clone-simulation");
        } else {
          createGame(
            this.form.gameName,
            this.form.additional_information,
            this.selectedScenario ? this.selectedScenario.locale : this.$i18n.locale,
            scenario_id,
            rps_scenario_id,
            this.form.demo,
            this.form.demoReason,
            enableComments,
            enableSurvey,
            parseInt(this.form.surveyScale),
            this.form.enable_billing,
            this.practice,
            simulation_type,
            this.form.enableSuggestions,
            selectedCases
          ).then(resp => {
            if (this.form.enableRobots && !this.practice) {
              generateRobots(resp.game_code, resp.id, this.form.numberOfRobots, this.$store);
            }

            this.form.gameCode = resp.game_code;
            this.newGameId = resp.id;
            this.newGameCreated = true;
            if (this.practice) {
              this.startPracticeGame();
            }
          });
        }
      } else {
        // Editmode
        if (!this.form.gameName) {
          this.alertMessage = "allfieldsrequired";
          return;
        }

        updateGameInfo(
          this.editid,
          this.form.gameCode,
          this.form.gameName,
          this.form.additional_information
        );
        this.$router.push("/admin/games/");
      }
    },
    simulationCloned(id) {
      // Only classic simulations can be cloned.
      createGame(
        this.form.gameName,
        this.form.additional_information,
        this.selectedScenario.locale,
        id,
        null,
        this.form.demo,
        this.form.demoReason,
        this.form.enableComments,
        this.form.enableSurvey,
        parseInt(this.form.surveyScale),
        this.form.enable_billing,
        this.practice,
        "classic",
        this.form.enableSuggestions
      ).then(resp => {
        if (this.form.enableRobots && !this.practice) {
          generateRobots(resp.game_code, resp.id, this.form.numberOfRobots, this.$store);
        }

        this.form.gameCode = resp.game_code;
        this.newGameCreated = true;
        this.newGameId = resp.id;

        if (this.practice) {
          this.startPracticeGame();
        }
      });
    },
    async startPracticeGame() {


      if (this.limitedFacilitator) {
        // Let's always activate robots for limited facilitators.
        this.form.enableRobots = true;
        this.form.numberOfRobots = 5;
      }

      if (this.form.enableRobots) {
        await generateRobots(
          this.form.gameCode,
          this.newGameId,
          this.form.numberOfRobots,
          this.$store
        );
      }
      this.$store.dispatch("log", "Starting practice game");
      this.$router.push("/gamecode/" + this.form.gameCode);
    }
  }
};
</script>

<i18n>
{
  "en": {
    "entername": "* Name of the simulation, team or occasion (visible to players)",
    "createnew": "Create a new simulation",
    "edit": "Edit simulation",
    "save": "Save",
    "cancel": "Cancel",
    "savefirsthint": "Simulation code and URL for joining the simulation are created after you click save.",
    "gamecode": "Simulation code:",
    "close": "Close",
    "gamecreated": "New simulation created",
    "demo": "Demonstration simulation (non-billable)",
    "demoreason": "* Please provide information about the demo",
    "allfieldsrequired": "Please fill in all fields before proceeding.",
    "demoreasonrequired": "Please describe why this is a demonstration simulation",
    "enteradditionalinformation": "Additional information, e.g. customer, date, project (not visible to players)",
    "enablecommenting": "In each case, show participants the field 'What should we discuss in relation to this topic?'. The answers are shown to the facilitator immediately and are included in the facilitator report.",
    "enablesurvey": "Opens two questions for the participants in each case of the simulation, following the discussion related to nominations: the importance of the topic and the current status of the topic. The participants are shown the mean of the answers. This leads them to a deeper discussion on the topic and team's operations. The questions typically take about 30 minutes of the simulation time.",
    "surveyscale": "Scale used in additional questions",
    "enablebilling": "Billable game",
    "customize-simulation": "Select cases used in the game",
    "practicegame": "Practice game",
    "instructions": "With the practice game, you can get acquainted with the operation of the simulation in advance and practice acting as a facilitator. Human players cannot join a practice game, but you can take advantage of computer players. With help of computer players, you can see how the simulation works, without them you can quickly get acquainted with cases of the simulation. The practice game starts as soon as you create it. You cannot return to the game later, but you can create new practice games.",
    "computerplayers": "Add computer players",
    "start": "Start",
    "numberofcomputerplayers": "* Number of computer players (1-20):"
  },
  "fi": {
    "entername": "* Simulaation, tiimin tai tilaisuuden nimi (näkyy pelaajille)",
    "createnew": "Luo uusi simulaatio",
    "edit": "Muokkaa simulaatiota",
    "save": "Tallenna",
    "cancel": "Peru",
    "savefirsthint": "Koodi ja linkki simulaatioon liittymistä varten luodaan, kun olet tallentanut simulaation.",
    "gamecode": "Simulaation koodi:",
    "close": "Sulje",
    "gamecreated": "Uusi simulaatio luotu",
    "demo": "Esittelysimulaatio (ei laskutettava)",
    "demoreason": "* Mihin tarkoitukseen simulaatiota esitellään",
    "allfieldsrequired": "Täytäthän kaikki kentät ennen jatkamista.",
    "demoreasonrequired": "Kerro miksi kyseessä on esittelysimulaatio",
    "enteradditionalinformation": "Yksilöintitietoa, esimerkiksi asiakas, päiväys, projekti (ei näy pelaajille)",
    "enablecommenting": "Näytä pelaajille kenttä 'Mistä meidän tulisi keskustella aiheeseen liittyen?' jokaisen tilanteen yhteydessä. Kaikkien vastaukset näkyvät fasilitaattorille välittömästi ja fasilitaattorin raportissa.",
    "enablesurvey": "Avaa pelaajille kaksi kysymystä simulaation jokaisessa tilanteessa nimeämisiin liittyvän keskustelun jälkeen: asian tärkeys ja tämänhetkinen taso. Pelaajat näkevät vastausten keskiarvon. Tämä johdattaa pelaajia syventävään keskusteluun aiheesta ja tiimin toiminnasta. Kysymyksiin kuluu noin 30 minuuttia peliajasta.",
    "surveyscale": "Lisäkysymyksissä käytettävä asteikko",
    "enablebilling": "Laskutettava peli",
    "customize-simulation": "Valitse tilanteet joita simulaatiossa käytetään",
    "practicegame": "Harjoituspeli",
    "instructions": "Harjoituspelillä voit tutustua etukäteen simulaation toimintaan ja harjoitella pelinjohtajana toimimista. Ihmispelaajat eivät voi liittyä harjoituspeliin, mutta voit hyödyntää tietokonepelaajia. Tietokonepelaajien avulla näet miten simulaatio toimii, ilman niitä pystyt nopeasti tutustumaan simulaation tilanteisiin. Harjoituspeli alkaa heti kun olet sen luonut. Et voi palata peliin myöhemmin, mutta voit luoda uusia harjoituspelejä.",
    "computerplayers": "Lisää tietokonepelaajia",
    "start": "Aloita",
    "numberofcomputerplayers": "* Tietokonepelaajien määrä (1-20):"
  },
 "sv": {
    "entername": "* Simuleringens, teamets eller evenemangets namn (synligt för spelare)",
    "createnew": "Skapa en ny simulering",
    "edit": "Redigera simuleringen",
    "save": "Spara",
    "cancel": "Ångra",
    "savefirsthint": "Koden och länken för att gå med i simuleringen skapas när du har sparat simuleringen.",
    "gamecode": "Simuleringskod:",
    "close": "Stäng",
    "gamecreated": "Ny simulering skapad",
    "demo": "Demosimulering (ej fakturerad)",
    "demoreason": "* I vilket syfte visas simuleringen",
    "allfieldsrequired": "Vänligen fyll i alla fält innan du fortsätter.",
    "demoreasonrequired": "Förklara varför detta är en demonstrationssimulering",
    "enteradditionalinformation": "Identifieringsinformation som kund, datum, projekt (inte synligt för spelare)",
    "enablecommenting": "Visa fältet för deltagarna i varje situation 'Vad ska vi diskutera i relation till detta ämne?'. Svaren visas omedelbart för spelledaren  och i spelledar-rapporten.",
    "enablesurvey": "Öppnar två frågor för deltagarna vid varje situation i  simuleringen, följer diskussionen relaterad till nomineringarna, ämnets betydelse och ämnets aktuella status. Deltagarna får se medelvärdet av svaren. Detta leder dem till en djupare diskussion om ämnet och gruppens verksamhet. Frågorna utökar den tid som behövs för simuleringen vanligtvis med 30 minuter.",
    "surveyscale": "Skala som används i ytterligare frågor",
    "enablebilling": "Fakturerbart spel",
    "customize-simulation": "Välj fall som används i spelet",
    "practicegame": "Öva spel",
    "instructions": "Med övningsspelet kan du bekanta dig med hur simuleringen fungerar i förväg och öva dig på att fungera som spelledare  Mänskliga spelare kan inte gå med i ett övningsspel, men du kan dra nytta av datorspelare. Med hjälp av datorspelare kan du se hur simuleringen fungerar, utan dem kan du snabbt bekanta dig med de olika stegen i simuleringen. Övningsspelet börjar så snart du skapar det. Du kan inte återvända till spelet senare, men du kan skapa nya övningsspel.",
    "computerplayers": "Lägg till datorspelare",
    "start": "Start",
    "numberofcomputerplayers": "* Antal datorspelare (1-20):"
  },
 "de": {
    "entername": "* Name der Simulation, des Teams oder des Anlasses (für Spieler sichtbar)",
    "createnew": "Neue Simulation erstellen",
    "edit": "Simulation bearbeiten",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "savefirsthint": "Der Simulationscode und die URL für die Teilnahme an der Simulation werden erstellt, nachdem Sie auf Speichern geklickt haben.",
    "gamecode": "Simulationscode:",
    "close": "Schließen",
    "gamecreated": "Neue Simulation erstellt",
    "demo": "Demonstrations-Simulation (nicht abrechenbar)",
    "demoreason": "* Bitte geben Sie Informationen über die Demo an",
    "allfieldsrequired": "Bitte füllen Sie alle Felder aus, bevor Sie fortfahren.",
    "demoreasonrequired": "Bitte beschreiben Sie, warum dies eine Demonstrationssimulation ist",
    "enteradditionalinformation": "Zusätzliche Informationen, z. B. Kunde, Datum, Projekt (für Spieler nicht sichtbar)",
    "enablecommenting": "Zeigen Sie den Teilnehmern jeweils das Feld 'Was sollen wir zu diesem Thema besprechen?'. Die Antworten werden dem Spielmanager sofort angezeigt, und im Spielmanager Bericht.",
    "enablesurvey": "Öffnet zwei Fragen für die Teilnehmer in jedem Fall der Simulation nach der Diskussion über Nominierungen: die Wichtigkeit des Themas und den aktuellen Status des Themas. Den Teilnehmern wird der Mittelwert der Antworten angezeigt. Dies führt sie zu einer tieferen Diskussion über das Thema und die Arbeitsweise des Teams. Die Fragen erhöhen den Zeitaufwand für die Simulation in der Regel um 30 Minuten.",
    "surveyscale": "In zusätzlichen Fragen verwendete Skala",
    "enablebilling": "Abrechnungsfähiges Spiel",
    "customize-simulation": "Wählen Sie Fälle aus, die im Spiel verwendet werden",
    "practicegame": "Übungsspiel",
    "instructions": "Mit dem Übungsspiel können Sie sich vorab mit der Funktionsweise der Simulation vertraut machen und üben, als Moderator zu agieren. Menschliche Spieler können nicht an einem Übungsspiel teilnehmen, aber Sie können Computer-Playern ausnutzen. Mit Hilfe von Computer-Playern können Sie sehen, wie die Simulation funktioniert, ohne sie können Sie sich schnell mit Fällen der Simulation vertraut machen. Das Übungsspiel beginnt, sobald Sie es erstellt haben. Sie können später nicht zum Spiel zurückkehren, aber Sie können neue Übungsspiele erstellen.",
    "computerplayers": "Computer-Player hinzufügen",
    "start": "Start",
    "numberofcomputerplayers": "* Anzahl der Computerspieler (1-20):"    
  },
"ko": {
    "entername": "* 시뮬레이션 이름, 그룹/팀 이름 등 (전체공개)",
    "createnew": "신규 시뮬레이션 개설",
    "edit": "시뮬레이션 수정",
    "save": "저장",
    "cancel": "취소",
    "savefirsthint": "저장을 누르시면 시뮬레이션에 접속할 수 있는 코드와 URL이 개설됩니다.",
    "gamecode": "시뮬레이션 코드:",
    "close": "닫기",
    "gamecreated": "신규 시뮬레이션이 개설되었습니다.",
    "demo": "프로모션 게임 (무료)",
    "demoreason": "* 프로모션 게임 개설 사유를 입력하십시오.",
    "allfieldsrequired": "모든 정보를 입력해주십시오.",
    "demoreasonrequired": "프로모션 게임 개설 사유를 입력하십시오.",
    "enteradditionalinformation": "고객사, 날짜, 교육명 등 추가 정보 (퍼실리테이터/관리자에게만 공개됨)",
    "enablecommenting": "각 주제와 관련해 논의해야 할 사항을 남길 수 있는 댓글창을 표시합니다. 참여자가 작성한 내용은 퍼실리테이터에게 전달되며 퍼실리테이터 결과보고서에 포함됩니다.",
    "enablesurvey": "각 주제와 관련된 두 개의 추가질문을 표시합니다. 팀원 지목과 관련된 토의를 마친 뒤, 각 주제의 중요도와 현재 수준을 묻는 질문을 진행합니다. 참여자는 응답 평균점수를 확인하고 팀 운영에 대해 토의합니다. 추가질문 진행 시 시뮬레이션 진행시간이 약 30분이 더 소요됩니다. ",
    "surveyscale": "점수 범위 선택",
    "enablebilling": "Billable game",
    "customize-simulation": "주제 선택하기",
    "practicegame": "모의시뮬레이션",
    "instructions": "모의시뮬레이션을 통해 시뮬레이션 조작법과 퍼실리테이터의 역할을 미리 숙지할 수 있습니다. 실제 플레이어가 참여할 수 없으며 컴퓨터 플레이어를 통해 시뮬레이션이 어떻게 작동하는지 확인할 수 있습니다. 모의시뮬레이션을 누르는 즉시 시작됩니다. 일시정지 혹은 저장할 수 없으나 언제든지 새로 시작할 수 있습니다. ",
    "computerplayers": "컴퓨터 플레이어 추가",
    "start": "시작",
    "numberofcomputerplayers": "* 컴퓨터 플레이어 수 (1-20):"        
  }
}
</i18n>
